/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue } from '../../../../Fct/generics';
import { ROUTER_ADDRESSES } from '../constants';
export var params = {
    input: {
        to: new FctAddress({ destination: 'sushiswap_router' }),
        methodParams: {
            tokenA: new FctAddress({ destination: 'erc20' }),
            tokenB: new FctAddress({ destination: 'erc20' }),
            amountADesired: new FctValue({ destination: 'wei_amount' }),
            amountBDesired: new FctValue({ destination: 'wei_amount' }),
            amountAMin: new FctValue({ destination: 'wei_amount' }),
            amountBMin: new FctValue({ destination: 'wei_amount' }),
            to: new FctAddress({}),
            deadline: new FctTimestamp({}),
        },
    },
    output: {
        amountA: new FctValue({ innerIndex: 0 }),
        amountB: new FctValue({ innerIndex: 1 }),
        liquidity: new FctValue({ innerIndex: 2 }),
    },
};
export var AddLiquidity = createPlugin({
    protocol: 'SUSHISWAP',
    type: 'ACTION',
    method: 'addLiquidity',
    description: 'Add liquidity on Sushiswap',
    supportedContracts: ROUTER_ADDRESSES,
    getParams: function () { return params; },
    initParams: {
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
    requiredApprovals: function (params) { return [
        {
            to: params.methodParams.tokenA.value,
            params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amountADesired.value },
            method: 'approve',
            protocol: 'ERC20',
        },
        {
            to: params.methodParams.tokenB.value,
            params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amountBDesired.value },
            method: 'approve',
            protocol: 'ERC20',
        },
    ]; },
});
